export default __webpack_public_path__ + "static/media/WORLD_LANGUAGES_REMIX.85ca231c.svg";